import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_follow_any_of_the_following_practices_related_to_w_1'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_follow_any_of_the_following_practices_related_to_w_1',
  name: 'Does the facility follow any of the following practices related to worker pregnancy at any time during employment?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_REQUIRES_PREGNANCY_TEST_AT_ANY_TIME_DURING_EMPLOYMENT',
      text: 'Facility requires pregnancy test at any time during employment',
      externalIds: [
        {
          id: 'disc-8--2-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARE_THE_TESTS_REQUIRED_BY_APPLICABLE_LEGISLATION_REGARDING_I_WO',
      text: 'Are the tests required by applicable legislation regarding (i) work that is legally prohibited or restricted for pregnant or nursing women, or (ii) work that presents a recognized or significant risk to the health of the woman and child?',
      externalIds: [
        {
          id: 'wt-dis-31',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_REQUIRES_THE_USE_OF_CONTRACEPTIVES_OR_OTHER_FORMS_OF_B',
      text: 'Facility requires the use of contraceptives or other forms of birth control at any time during employment',
      externalIds: [
        {
          id: 'disc-8--2-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'disc-8--2-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_REQUIRES_PREGNANCY_TEST_AT_ANY_TIME_DURING_EMPLOYMENT',
                'ARE_THE_TESTS_REQUIRED_BY_APPLICABLE_LEGISLATION_REGARDING_I_WO',
                'FACILITY_REQUIRES_THE_USE_OF_CONTRACEPTIVES_OR_OTHER_FORMS_OF_B',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-dis-30',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11340,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
